// 联系内容
import classNames from 'classnames'
import React, { useState, useEffect } from 'react'
import styles from './contact.module.scss'

interface Props {}

const Contact: React.FC<Props> = () => {
  const [hostname, setHostname] = useState('')

  useEffect(() => {
    setHostname(window.location.hostname)
  }, [])


  return (
    <div className={styles.contact}>
      <div className={classNames(styles.main)}>
        <div className={classNames(styles.title, styles.ignoreConvert)}>
          {hostname === 'form-h5.shenlian100.com' ? '百满分' : '百满花'} APP
        </div>
        <div className={styles.ignoreConvert}>如有任何疑问，您可以通过以下方式联系我们</div>
        <div className={styles.ignoreConvert}>
          email： {hostname === 'form-h5.shenlian100.com' ? '000@qq.com' : '0000@qq.com'}
        </div>
        <div className={styles.ignoreConvert}>
          客服电话：{hostname === 'form-h5.shenlian100.com' ? '19990000000' : '19990000000'}
        </div>
      </div>
    </div>
  )
}

export default Contact
